module.exports = __webpack_public_path__ + "img/Logo_Flui3d.34525e19.svg";